exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.i(require("-!../../../../../../node_modules/css-loader/index.js?{\"sourceMap\":false,\"importLoaders\":1}!../../../../../../node_modules/postcss-loader/index.js!./../../../../../styles.css"), "");

// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/modal/simple-info-edcast/simple-info-edcast.component.css
// module id = 842
// module chunks = 0